import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { pipe } from 'fp-ts/lib/function';
import { callUndo } from 'utils/history/CallbackHistory';

export const undo: GraphCommandFactory = (cmdContext) => () => {
  pipe(cmdContext.getState().history, callUndo, (history) =>
    cmdContext.updateState((draft) => {
      draft.history = history;
    }),
  );
};
